import {
  Component,
  ElementRef,
  Input,
  NgModule,
  ViewChild,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from '../_services/authentication.service';
import { CartService } from '../_services/cart.service';
import { Role } from '../_models/role';
import { UserService } from '../_services/user.service';
import { StyleClass } from 'primeng/styleclass';
import { ClinicService } from '../_services/clinic.service';
// import { BulkOrderFormService } from '../_services/bulk-order-form.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  mainitems: MenuItem[];
  profileitems: MenuItem[];
  menu: any;
  isMenuVisible: boolean = false;
  @Input() user: any = this.authenticationService.userValue;
  currentUser: any;
  cartItems: any[] = [];
  cartLength: any;
  roles: typeof Role = Role;
  user$ = this.authenticationService.user;
  @Input() menuItems: any[] = [];
  filteredMenuItems: any[] = [];
  menuItem: any;
  hasSubChild: boolean = false;
  currentYear: number = new Date().getFullYear();
  hasAccess: boolean = false;
  userRole: any;
  bulkOrderCount: any;
  subMenuItems: any[] = [];
  clinicCredit: any;
  // bulkOrderCount$ = this.bulkOrderFormService.reviewCount$;

  showFiller = false;
  isVisible: boolean = false;
  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    public authenticationService: AuthenticationService,
    private cartService: CartService,
    public userService: UserService,
    private clinicService: ClinicService // private bulkOrderFormService: BulkOrderFormService
  ) {
    this.user = this.authenticationService.userValue;

    if (this.user) {
      this.mainitems = [
        { label: 'Home', routerLink: '' },
        { label: 'Get Quote', routerLink: 'getquote' },
      ];
    } else {
      this.mainitems = [
        // { label: 'Home', routerLink: '/' },
        // { label: 'Things To Do', routerLink: 'thingstodo' },
        // { label: 'Table', routerLink: 'table' },
        { label: 'Login', routerLink: 'login' },
      ];
    }

    this.profileitems = [
      {
        label: 'Logout',
        command: () => {
          this.authenticationService.logout();
        },
      },
    ];
  }

  sidebarVisible = false;
  isMobile: boolean = false;

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  }

  ngOnInit(): void {
    this.isHandset$.subscribe((isHandset) => {
      this.isMobile = isHandset;
    });

    this.cartService.cartItems$.subscribe((items) => {
      this.cartItems = items;
      this.cartLength = this.cartItems.length;
    });

    this.userService.getCurrentLoggedInUser();

    this.authenticationService.user.subscribe((user) => {
      this.currentUser = user;
    })
    

    // this.clinicService.getAssignedClinics().subscribe((response: any) => {
    //   console.log('Clinic credit response in Nav', response);

    //   this.clinicService.getCinicCredit(response.body.data[0].id).subscribe();
    //   this.clinicService.clinicCredit$.subscribe((credit) => {
    //     this.clinicCredit = credit;
    //   });
    // });

    // setTimeout(() => {
    //   this.bulkOrderFormService.getBulkOrderActionCount().subscribe((data) => {
    //     this.bulkOrderFormService.updateReviewCount(data.body);
    //     this.bulkOrderCount$.subscribe((count) => {
    //       this.bulkOrderCount = count;
    //     });
    //   });
    // }, 1000);

    if (
      Role.Admin ||
      Role.Customer_ZPL ||
      Role.Basic_ZPL ||
      Role.Customer_PIFSA
    ) {
      this.hasAccess = true;
    } else {
      this.hasAccess = false;
    }

    this.userService.currentUser$.subscribe((user) => {
      this.userRole = user?.role?.name;
      this.clinicService.getAssignedClinics().subscribe((response: any) => {
        if (response.body.data.length > 0) {
          this.clinicService
            .getCinicCredit(response.body.data[0].id)
            .subscribe();
          this.clinicService.clinicCredit$.subscribe((credit) => {
            this.clinicCredit = credit;
          });
        }
      });
    });

    this.menuItems = [
      {
        label: 'Home',
        routerLink: '/',
        icon: 'pi pi-home',
        rolesWithAccess: [
          Role.Admin,
          Role.Customer_ZPL,
          Role.Basic_ZPL,
          Role.Customer_PIFSA,
          Role.HQ_Clinic_Admin,
          Role.Clinic_Admin,
          Role.ZPL_Cinic_Admin,
          Role.Admin_BulkOrders,
          Role.Admin_Switch,
        ],
      },
      {
        label: 'Switch Settings',
        routerLink: 'switch-admin',
        icon: 'pi pi-cog',
        rolesWithAccess: [Role.Admin_Switch],
      },
      // {
      //   label: 'Bulk Order Settings',
      //   routerLink: 'admin-bulkorders',
      //   icon: 'pi pi-cog',
      //   rolesWithAccess: [Role.Review_BulkOrders]
      // },
      {
        label: 'Actions',
        icon: 'pi pi-th-large',
        rolesWithAccess: [
          Role.Admin,
          Role.Customer_ZPL,
          Role.Customer_PIFSA,
          Role.Review_BulkOrders,
          Role.Admin_BulkOrders,
        ],
        childMenuItem: [
          {
            label: 'Generate',
            icon: 'pi pi-plus-circle',
            rolesWithAccess: [
              Role.Admin,
              Role.Customer_ZPL,
              Role.Customer_PIFSA,
              Role.Admin_BulkOrders,
            ],
            childSubItem: [
              {
                label: 'Quote',
                routerLink: 'generatequote',
                icon: 'pi pi-plus-circle',
                rolesWithAccess: [Role.Admin, Role.Customer_ZPL],
              },
              {
                label: 'Artwork',
                routerLink: 'artwork',
                icon: 'pi pi-plus-circle',
                rolesWithAccess: [Role.Admin, Role.Customer_PIFSA],
              },
              {
                label: 'Bulk Orders',
                routerLink: 'bulk-orders',
                icon: 'pi pi-plus-circle',
                rolesWithAccess: [Role.Admin, Role.Admin_BulkOrders],
              },
            ],
          },
          {
            label: 'View',
            icon: 'pi pi-eye',
            rolesWithAccess: [
              Role.Admin,
              Role.Customer_ZPL,
              Role.Customer_PIFSA,
              Role.Review_BulkOrders,
              Role.Admin_BulkOrders,
            ],
            childSubItem: [
              {
                label: 'My Quotes',
                routerLink: 'viewmyquotes',
                icon: 'pi pi-shopping-cart',
                rolesWithAccess: [Role.Admin, Role.Customer_ZPL],
              },
              {
                label: 'My Artworks',
                routerLink: 'view-artwork',
                icon: 'pi pi-shopping-cart',
                rolesWithAccess: [Role.Admin, Role.Customer_PIFSA],
              },
              {
                label: 'View Bulk Orders',
                routerLink: 'view-bulk-orders',
                icon: 'pi pi-users',
                rolesWithAccess: [
                  Role.Admin,
                  Role.Review_BulkOrders,
                  Role.Admin_BulkOrders,
                ],
              },
              {
                label: 'View Rejected Orders',
                routerLink: 'rejected-bulk-orders',
                icon: 'pi pi-eye',
                rolesWithAccess: [
                  Role.Admin,
                  Role.Review_BulkOrders,
                  Role.Admin_BulkOrders,
                ],
              },
              {
                label: 'Review Bulk Orders',
                routerLink: 'review-bulk-orders',
                icon: 'pi pi-eye',
                rolesWithAccess: [
                  Role.Admin,
                  Role.Review_BulkOrders,
                  Role.Admin_BulkOrders,
                ],
              },
            ],
          },
        ],
      },

      {
        label: 'Admin',
        icon: 'pi pi-chart-line',
        rolesWithAccess: [Role.Admin, Role.Admin_Switch],
        childMenuItem: [
          {
            label: 'Views',
            icon: 'pi pi-eye',
            rolesWithAccess: [Role.Admin, Role.Admin_Switch],
            childSubItem: [
              {
                label: 'View Estimates',
                routerLink: 'quote-admin-table',
                icon: 'pi pi-chart-bar',
                rolesWithAccess: [Role.Admin],
              },
              {
                label: 'View Products',
                routerLink: 'product',
                icon: 'pi pi-cog',
                rolesWithAccess: [Role.Admin],
              },
              {
                label: 'View Customers',
                routerLink: 'customer-table',
                icon: 'pi pi-users',
                rolesWithAccess: [Role.Admin],
              },

              {
                label: 'View Webhooks',
                routerLink: 'switch-webhook-admin',
                icon: 'pi pi-users',
                rolesWithAccess: [Role.Admin, Role.Admin_Switch],
              },
            ],
          },
          {
            label: 'Actions',
            icon: 'pi pi-th-large',
            rolesWithAccess: [Role.Admin, Role.Admin_Switch],
            childSubItem: [
              {
                label: 'Create Switch Webhook',
                routerLink: 'switch-webhook',
                icon: 'pi pi-plus-circle',
                rolesWithAccess: [Role.Admin, Role.Admin_Switch],
              },
              {
                label: 'Create Bulk Order Type',
                routerLink: 'create-order-type',
                icon: 'pi pi-plus-circle',
                rolesWithAccess: [Role.Admin, Role.Admin_BulkOrders],
              },
            ],
          },
        ],
      },
      {
        label: 'Settings',
        routerLink: 'settings',
        icon: 'pi pi-cog',
        rolesWithAccess: [
          Role.Admin,
          Role.Customer_ZPL,
          Role.Basic_ZPL,
          Role.Customer_PIFSA,
        ],
      },
    ];

    this.subMenuItems = [
      {
        label: 'Dashboard',
        icon: 'pi pi-users',
        routerLink: ['/admin-dashboard'],
        rolesWithAccess: [
          Role.Admin,
          Role.HQ_Clinic_Admin,
          Role.ZPL_Cinic_Admin,
          Role.HQ_Clinic_User,
        ],
      },
      {
        label: 'Dashboard',
        icon: 'pi pi-box',
        routerLink: ['/my-clinics'],
        rolesWithAccess: [Role.Clinic_Admin],
      },
      {
        label: 'Settings',
        icon: 'pi pi-cog',
        routerLink: ['/settings'],
        rolesWithAccess: [
          Role.HQ_Clinic_Admin,
          Role.ZPL_Cinic_Admin,
          Role.HQ_Clinic_User,
        ],
      },
      {
        label: 'Products',
        icon: 'pi pi-box',
        routerLink: ['/clinic-products'],
        rolesWithAccess: [
          Role.Admin,
          Role.HQ_Clinic_Admin,
          Role.ZPL_Cinic_Admin,
        ],
      },
      {
        label: 'Orders',
        icon: 'pi pi-list',
        routerLink: ['/sales-order'],
        rolesWithAccess: [
          Role.Admin,
          Role.HQ_Clinic_Admin,
          Role.ZPL_Cinic_Admin,
          Role.HQ_Clinic_User,
        ],
      },
      {
        label: 'My Orders',
        icon: 'pi pi-list',
        routerLink: ['/clinic-orders'],
        rolesWithAccess: [Role.Clinic_Admin],
      },
    ];
  }

  toggleMenu(menuItem: any) {
    // Toggle the expanded state of the menu item
    if (menuItem.childMenuItem) {
      menuItem.isExpanded = !menuItem.isExpanded;
    }

    // Close other expanded menus
    this.menuItems.forEach((item: any) => {
      if (item !== menuItem && item.isExpanded) {
        item.isExpanded = false;
      }
    });
  }

  toggleSubMenu(childMenuItem: any) {
    // Toggle the expanded state of the child menu item
    if (childMenuItem.childSubItem) {
      childMenuItem.isExpanded = !childMenuItem.isExpanded;
    }

    // Close other expanded sub-menus in the same parent
    const parentMenuItem = this.menuItems.find(
      (item: any) =>
        item.childMenuItem && item.childMenuItem.includes(childMenuItem)
    );

    if (parentMenuItem) {
      parentMenuItem.childMenuItem.forEach((item: any) => {
        if (item !== childMenuItem && item.isExpanded) {
          item.isExpanded = false;
        }
      });
    }
  }

  // Mobile Navigation Methods
  closeMobileMenu() {
    const mobileMenu = document.getElementById('mobile-nav-menu');
    if (mobileMenu) {
      mobileMenu.classList.add('hidden');
    }
  }

  openMobileMenu() {
    const mobileMenu = document.getElementById('mobile-nav-menu');
    if (mobileMenu) {
      mobileMenu.classList.remove('hidden');
    }
  }

  toggleMobileMenu(menuItem: any) {
    // Toggle the expanded state of the menu item for mobile
    if (menuItem.childMenuItem) {
      menuItem.isMobileExpanded = !menuItem.isMobileExpanded;
    }

    // Close other expanded menus
    this.menuItems.forEach((item: any) => {
      if (item !== menuItem && item.isMobileExpanded) {
        item.isMobileExpanded = false;
      }
    });
  }

  toggleMobileSubMenu(childMenuItem: any) {
    // Toggle the expanded state of the child menu item for mobile
    if (childMenuItem.childSubItem) {
      childMenuItem.isMobileExpanded = !childMenuItem.isMobileExpanded;
    }

    // Close other expanded sub-menus in the same parent
    const parentMenuItem = this.menuItems.find(
      (item: any) =>
        item.childMenuItem && item.childMenuItem.includes(childMenuItem)
    );

    if (parentMenuItem) {
      parentMenuItem.childMenuItem.forEach((item: any) => {
        if (item !== childMenuItem && item.isMobileExpanded) {
          item.isMobileExpanded = false;
        }
      });
    }
  }

  closeSidebar() {
    // Collapse all expanded menus
    this.menuItems.forEach((item: any) => {
      item.isExpanded = false;
      item.childMenuItem?.forEach((childItem: any) => {
        childItem.isExpanded = false;
      });
    });

    // If on mobile, hide the sidebar
    if (this.isMobile) {
      const sidebar = document.getElementById('app-sidebar-3');
      if (sidebar) {
        sidebar.classList.remove('modern-slide-out'); // in case it was stuck
        sidebar.classList.add('modern-slide-in');
        sidebar.classList.add('hidden');
      }
    }
  }

  isBurgerMenuVisible: boolean = true;

  toggleBurgerMenu() {
    this.isBurgerMenuVisible = !this.isBurgerMenuVisible;
  }

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(1)
    );
}
